export default __webpack_public_path__ + "static/orangefilingdust-3ec51b2dd9d11a454e1102a9dee93bad.png";